export default "__VITE_ASSET__CV0Gw0ST__"